<template>
	<div>
		<div class="tw-text-3xl tw-font-bold">
			{{ $t('integrations.create-shopify-application-title') }}
		</div>
		<div class="tw-font-medium tw-text-gray-500">
			{{ $t('integrations.create-shopify-application-description') }}
		</div>
		<div class="tw-mt-5">
			<AppButton
				v-if="!isDone"
				:label="$t('integrations.create-application')"
				size="xl"
				class="tw-rounded-full"
				:disabled="loading"
				@click="onCreateApplication"
			/>
			<AppButton
				v-else
				:label="$t('integrations.next-step')"
				size="xl"
				class="tw-rounded-full"
				type="button"
				endIcon="assets/v2/image/icons/arrow-narrow-right.svg"
				@click="nextStep"
				:loading="nextStepLoading"
			/>
		</div>
	</div>
</template>

<script setup>
import { Marketplace } from '../../../../entities/marketplace';
import { useLinkMarketplaceStore } from '../../../../stores/link-marketplace';
import { marketplaceStepStatusEnum } from '../../helper';
import { ref } from 'vue';

const linkMarketplaceStore = useLinkMarketplaceStore();

const loading = ref(
	linkMarketplaceStore.currentStepData.status === marketplaceStepStatusEnum.InProgress,
);
const isDone = ref(
	linkMarketplaceStore.currentStepData.status === marketplaceStepStatusEnum.Complete,
);
const nextStepLoading = ref(false);

const onCreateApplication = async () => {
	loading.value = true;

	const success = await Marketplace.createShopifyApp(linkMarketplaceStore.linkedMarketplaceId);
	if (!success) {
		document.location.href = '/store/subscribe/renew_package';
		return;
	}
	await linkMarketplaceStore.refetchSteps();
};

const nextStep = async () => {
	nextStepLoading.value = true;
	try {
		await Marketplace.finishWizardStep(linkMarketplaceStore.currentStepData.id);
		await linkMarketplaceStore.refetchSteps();
	} finally {
		nextStepLoading.value = false;
	}
};
</script>

<style lang="scss" scoped></style>
